<template>
  <div id="statistics-box">
    <!-- 右侧栏 -->
    <div :class="leftSideStatus ?'right-aside-active':'right-aside'">
      <!-- 头部 -->
      <div class='right-header'>
        <!--logo部分-->
        <div class="logo-box">
          <img :src="logo" class="logo-image">
          <strong class="logo">VR云展馆游览开发系统</strong>
        </div>
        <!--右侧头部主菜单-->
        <div class="right-header-menu-box">
          <!--菜单列表-->
          <ul class="header-menu-list">
            <li :class="item.activeStatus?'header-menu-list-item-active':'header-menu-list-item'" v-for="(item,index) in leftMenu" :key="item.index" @click="activeHeaderMenu(index,item.menuRouter)">
              <i class="iconfont" :class="[item.menuIcon,item.activeStatus?'left-menu-active':'left-menu']"></i>
              <span :class="item.activeStatus?'left-menu-active':'left-menu'">{{item.menuName}}</span>
            </li>
          </ul>
        </div>
        <div class="option-box" @mouseenter="show()" @mouseleave="hide()">
          <span class="user-name">admin</span>
          <i class="iconfont icon-down" :style="upStyle"></i>
        </div>
        <ul class="option-list" v-show="showOption" @mouseenter="show()" @mouseleave="hide()">
          <li class="option-item" v-for="(item,index) in optionsList" :key="index" @click=" redirectToPage(item.router)">{{item.name}}</li>
        </ul>
      </div>
      <!-- 子页面容器 -->
      <div class='child-component'>
        <!--左侧菜单-->
        <div class="content-left-menu">
          <ul class="menu-list">
            <li :class="item.isActive ? 'menu-item-active' : 'menu-item'" v-for="(item,index) in centerLeftMenu" :key="index" @click="changeChildrenPage(index,item.router)">
              <i class="iconfont" :class="item.icon"></i>
              <span>{{item.name}}</span>
            </li>
          </ul>
        </div>
        <!--右侧子页面-->
        <div class="right-children-page">
          <router-view></router-view>
        </div>
      </div>
      <!-- 底部版权 -->
      <div id='footer'>

      </div>
  </div>
  </div>
</template>

<script>
export default {
  name:'statistics',
    data() {
    return {
      logo: require('assets/img/logo/small-logo.svg'),
      leftSideStatus: false,
      leftSideOpenClass: '',
      leftMenu: [{
          menuName: '首页',
          menuIcon: 'icon-home',
          activeStatus: false,
          menuRouter: "/index",
        },
        {
          menuName: '模型',
          menuIcon: 'icon-model',
          activeStatus: false,
          menuRouter: "/model",
        },
        {
          menuName: '用户',
          menuIcon: 'icon-user',
          activeStatus: false,
          menuRouter: "/user",
        },
      ],
      showOption:false,
      upStyle:"transform: rotate(0deg);transition: all .5s ease-in-out;",
      optionsList:[
        {
          name:'基本资料',
          router:'/user/userDetail'
        },
        {
          name:'修改密码',
          router:''
        },
        {
          name:'全景设置',
          router:'/user/panoramaSet'
        },
        {
          name:'退出',
          router:'/'
        }
      ],
      centerLeftMenu:[
        {
          name:'数据概览',
          icon:'icon-data-overview',
          isActive:false,
          router:'/statistics/overview',
        },
        {
          name:'数据分析',
          icon:'icon-data-analysis',
          isActive:false,
          router:'/statistics/analysis',
        }
      ]
    };
  },
  mounted() {
    this.initMenu();
  },
  methods: {
    //动态更新菜单样式
    initMenu(){
      let activeMenu = window.sessionStorage.getItem('statisticsCenterLeftMenu');
      if(activeMenu !=undefined && activeMenu !=null & activeMenu !=''&& activeMenu >=0) {
        this.centerLeftMenu.forEach((item,index)=>{
          item.isActive = false;
        });
        this.centerLeftMenu[activeMenu].isActive = true;
        this.$router.push(this.centerLeftMenu[activeMenu].router);
      }else if (activeMenu < 0) {
        this.centerLeftMenu.forEach((item,index)=>{
          item.isActive = false;
        });
      }
      else {
        this.centerLeftMenu[0].isActive =true;
        this.$router.push(this.centerLeftMenu[0].router);
      }
    },
    // 收缩与扩展左侧菜单
    openLeftSideMenu() {
      this.leftSideStatus = !this.leftSideStatus;
      if (this.leftSideStatus) {
        this.leftSideOpenClass = 'left-aside-active';
      } else {
        this.leftSideOpenClass = '';
      }
    },
    //激活头部菜单
    activeHeaderMenu(index, router) {
      this.leftMenu.forEach((item, key) => {
        if (index == key) {
          item.activeStatus = true;
          window.sessionStorage.setItem("homeLeftActiveIndex",index);
        } else {
          item.activeStatus = false;
        }
      });
      if (router != undefined && router != null && router != '') {
        this.$router.push(router);
      }

    },
    //显示
    show() {
      this.showOption = true;
      this.upStyle = "transform: rotate(-180deg);transition: all .5s ease-in-out;"
    },
    //隐藏
    hide() {
      this.showOption = false;
      this.upStyle = "transform: rotate(0deg);transition: all .5s ease-in-out;"
    },
    //跳转至指定操作页面
    redirectToPage(router) {
      if(router !='') {
        this.$router.push(router);
      }
    },
    //切换子页面
    changeChildrenPage(index,router) {
      this.centerLeftMenu.forEach((item,key)=>{
        if(key == index) {
          item.isActive = true;
          window.sessionStorage.setItem("statisticsCenterLeftMenu",index);
        }else {
          item.isActive = false;
        }
      });
      if( router != '' && router != undefined && router != null ) {
        this.$router.push(router);
      }
    }
  },
  computed: {}
};
</script>

<style scoped src='../assets/css/common/animate.css'></style>
<style scoped src='../assets/css/components/Statistics.css'></style>